import React, { useMemo } from 'react';
import Icon from '../../../components/AppIcon';

import Select from '../../../components/ui/Select';

const SearchBar = ({
  searchTerm,
  onSearchChange,
  selectedIndustry,
  onIndustryChange,
  selectedStatus,
  onStatusChange,
  sortBy,
  onSortChange,
  viewMode,
  onViewModeChange,
  assignmentFilter,
  onAssignmentFilterChange,
  selectedTags,
  onSelectedTagsChange,
  selectedCampaignId,
  onSelectedCampaignChange,
  filterMeta,
  loadingFilterMeta,
}) => {
  const tagOptions = useMemo(() => {
    const rows = filterMeta?.tags || [];
    if (rows.length > 0) {
      return rows.map((t) => ({
        value: t.name,
        label: `${t.name} (${t.count})`,
      }));
    }
    return [];
  }, [filterMeta?.tags]);

  const campaignOptions = useMemo(() => {
    const base = [{ value: '', label: 'Toutes les campagnes' }];
    const rows = filterMeta?.campaigns || [];
    rows.forEach((c) => {
      const tagHint =
        Array.isArray(c.tags) && c.tags.length > 0
          ? ` · ${c.tags.join(', ')}`
          : ' · sans tags';
      base.push({
        value: c.id,
        label: `${c.name} (${c.count})${tagHint}`,
      });
    });
    return base;
  }, [filterMeta?.campaigns]);

  const statusOptions = [
    { value: 'all', label: 'Tous les statuts' },
    { value: 'prospect', label: 'Prospect' },
    { value: 'qualifie', label: 'Qualifié' },
    { value: 'proposition', label: 'Proposition' },
    { value: 'negociation', label: 'Négociation' },
    { value: 'conclu', label: 'Conclu' },
    { value: 'non_interesse', label: 'Non intéressé' },
  ];

  const sortOptions = [
    { value: 'recent', label: 'Plus récent' },
    { value: 'name', label: 'Nom A-Z' },
    { value: 'company', label: 'Entreprise' },
    { value: 'priority', label: 'Priorité' },
  ];

  const assignmentOptions = [
    { value: '', label: 'Tous les prospects' },
    { value: 'mine', label: 'Mes prospects assignés' },
    { value: 'unassigned', label: 'Prospects non assignés' },
  ];

  return (
    <div className="bg-card rounded-lg p-4 md:p-6 shadow-elevation-2 space-y-3">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-3">
        <div className="lg:col-span-3">
          <div className="relative">
            <Icon
              name="Search"
              size={18}
              className="absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground"
            />
            <input
              type="text"
              placeholder="Rechercher par nom, entreprise, email..."
              value={searchTerm}
              onChange={(e) => onSearchChange(e?.target?.value)}
              className="w-full h-10 pl-10 pr-4 rounded-md border border-input bg-background text-sm focus:outline-none focus:ring-2 focus:ring-ring"
            />
          </div>
        </div>

        <div className="lg:col-span-2">
          <Select
            options={statusOptions}
            value={selectedStatus}
            onChange={onStatusChange}
            placeholder="Statut"
          />
        </div>

        <div className="lg:col-span-2">
          <Select
            options={sortOptions}
            value={sortBy}
            onChange={onSortChange}
            placeholder="Trier par"
          />
        </div>

        <div className="lg:col-span-2">
          <Select
            options={tagOptions}
            value={selectedTags}
            onChange={onSelectedTagsChange}
            placeholder="Tags (effectifs)"
            multiple
            searchable
            clearable
            loading={loadingFilterMeta}
          />
        </div>

        <div className="lg:col-span-2">
          <Select
            options={assignmentOptions}
            value={assignmentFilter}
            onChange={onAssignmentFilterChange}
            placeholder="Assignation"
          />
        </div>

        <div className="lg:col-span-1 flex items-center justify-end">
          <div className="flex items-center gap-1 bg-muted rounded-lg p-1">
            <button
              onClick={() => onViewModeChange('grid')}
              className={`p-2 rounded transition-smooth ${
                viewMode === 'grid' ? 'bg-background shadow-sm' : 'hover:bg-background/50'
              }`}
              aria-label="Vue grille"
            >
              <Icon name="LayoutGrid" size={18} />
            </button>
            <button
              onClick={() => onViewModeChange('list')}
              className={`p-2 rounded transition-smooth ${
                viewMode === 'list' ? 'bg-background shadow-sm' : 'hover:bg-background/50'
              }`}
              aria-label="Vue liste"
            >
              <Icon name="List" size={18} />
            </button>
          </div>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-3">
        <div className="lg:col-span-6">
          <Select
            options={campaignOptions}
            value={selectedCampaignId || ''}
            onChange={(v) => onSelectedCampaignChange(v || '')}
            placeholder="Filtrer par campagne"
            searchable
            clearable
            loading={loadingFilterMeta}
          />
        </div>
      </div>
    </div>
  );
};

export default SearchBar;
